import { EcommerceProductCityPriceHikeModel } from './EcommerceProductCityPriceHikeModel';
export class EcommerceProductRegionAvailabilityModel {
    constructor(payload) {
        this.uuid = payload.uuid;
        this.deliveryAreaRegion = payload.deliveryAreaRegion;
        const initCityHike = (po) => {
            return new EcommerceProductCityPriceHikeModel(po.node);
        };
        this.productCityPriceHikes = payload.productCityPriceHikes.edges.map(initCityHike);
    }
}
